import React from 'react'

export type CompatImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'width' | 'height'> & {
  src: string
  width?: number
  height?: number
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive'
  objectFit?: React.CSSProperties['objectFit']
  objectPosition?: React.CSSProperties['objectPosition']
  priority?: boolean
  /** next/image compat — ignored at runtime */
  quality?: number
  loader?: (args: { src: string; width?: number; quality?: number }) => string
  placeholder?: string
  blurDataURL?: string
  unoptimized?: boolean
}

const CompatImage: React.FC<CompatImageProps> = ({
  src,
  alt = '',
  width,
  height,
  layout,
  objectFit,
  objectPosition,
  className,
  style,
  quality: _quality,
  loader: _loader,
  placeholder: _placeholder,
  blurDataURL: _blurDataURL,
  priority: _priority,
  unoptimized: _unoptimized,
  ...rest
}) => {
  if (layout === 'fill') {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: objectFit ?? 'cover',
          objectPosition,
          ...style,
        }}
        {...rest}
      />
    )
  }

  const intrinsicContain =
    width === undefined && height === undefined
      ? ({ maxWidth: '100%', height: 'auto' } as React.CSSProperties)
      : undefined

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={{ objectFit, objectPosition, ...intrinsicContain, ...style }}
      {...rest}
    />
  )
}

export default CompatImage
